/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import {KTIcon, toAbsoluteUrl} from '../../../_metronic/helpers'
import { Link } from 'react-router-dom'

type Props = {
  className: string
  color: string
  svgIcon: string
  iconColor: string
  title: string
  titleColor?: string
  description: string
  descriptionColor?: string
  icon?: any
    link?: any

}

const StatisticsWidgetVendor: React.FC<Props> = ({
  className,
  color,
  svgIcon,
  iconColor,
  title,
  titleColor,
  description,
  descriptionColor,
  icon="",
  link,

}) => {
  return (
    <Link to={link}  className={`card bg-${color} hoverable ${className} position-relative`}>
      <img
        alt='images'
        src={toAbsoluteUrl('/media/otherSVG/Mask group (2).svg')}
        className='position-absolute top-0 end-0'
      />
      <div className='card-body'>
        {icon != '' && icon != null ? (
          <img alt='images' src={toAbsoluteUrl('/media/otherSVG/' + icon)} />
        ) : (
          <KTIcon iconName={svgIcon} className={`text-${iconColor} fs-3x ms-n1 themeGreenColor`} />
        )}

        <div className={`fs-2 mt-20 d-flex justify-content-between align-items-center`}>
          <span className={`text-${titleColor} fw-bold w-100`}>{title}</span>
          <span className={`fw-semibold text-${descriptionColor}`}>{description}</span>
        </div>
      </div>
    </Link>
  )
}

export {StatisticsWidgetVendor}
